import { DataSource } from '@softapps/core';
import { FilterState } from '../../filter.state';
import { PageFilterFactoryRef } from './page-filter.function';
import { pageFilterDataServiceFactory } from '../services/data-source/page-filter-data-service.factory';
import { Signal } from '@angular/core';
import { QueryFilter } from '@softline/core';
import { Translation } from '@softline/ui-core';

export interface PageFilterSourceOptions<T extends object> {
  /** query repository, or client-side rows (array, signal, resource) */
  dataSource: DataSource<T>;
  state: FilterState<T>;
  /** always-on restriction applied to every value query, e.g. the selected period */
  baseFilter?: Signal<QueryFilter<T>>;
  /** label shown in the custom tab's datasource selector */
  title?: Signal<Translation>;
}

export function pageFilterSource<T extends object>(ref: PageFilterFactoryRef, options: PageFilterSourceOptions<T>) {
  const dataService = pageFilterDataServiceFactory(options.dataSource, options.baseFilter)
  const source = {dataService, state: options.state, title: options.title};
  ref.addSource(source)
  return source;
}
